var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-tabs",
        {
          staticClass: "q-mb-md",
          attrs: { inverted: "" },
          model: {
            value: _vm.selectedTab,
            callback: function($$v) {
              _vm.selectedTab = $$v
            },
            expression: "selectedTab"
          }
        },
        [
          _c("q-tab", {
            attrs: { slot: "title", name: "active", label: "Active" },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: { slot: "title", name: "inactive", label: "Incomplete" },
            slot: "title"
          })
        ],
        1
      ),
      _c("div", { staticClass: "row full-row-exactly" }, [
        _c("div", { staticClass: "col-12 flex-1" }, [
          _c(
            "div",
            {
              staticClass: "gutter-sm",
              class: _vm.$q.screen.lt.md ? "column" : "row"
            },
            [
              _vm.$q.screen.lt.md || _vm.showFiltersDesktop
                ? _c(
                    "div",
                    {
                      class:
                        _vm.$q.screen.lt.md && !_vm.showFiltersMobile
                          ? "col-auto"
                          : "col-md-3"
                    },
                    [
                      _c(
                        "q-card",
                        { class: _vm.$q.screen.gt.sm ? "full-height" : "" },
                        [
                          _c("q-card-title", [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  Filters\n                "
                                )
                              ]),
                              _vm.$q.screen.lt.md
                                ? _c(
                                    "div",
                                    { staticClass: "col-auto q-mr-auto" },
                                    [
                                      _c("q-btn", {
                                        attrs: {
                                          color: "secondary",
                                          flat: "",
                                          round: "",
                                          icon:
                                            "keyboard_arrow_" +
                                            (_vm.showFiltersMobile
                                              ? "up"
                                              : "down")
                                        },
                                        on: { click: _vm.toggleFiltersMobile }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm.$q.screen.gt.sm || _vm.showFiltersMobile
                            ? _c(
                                "q-card-main",
                                {
                                  staticStyle: { height: "calc(100% - 64px)" }
                                },
                                [
                                  _c(
                                    _vm.$q.screen.gt.sm
                                      ? "q-scroll-area"
                                      : "div",
                                    {
                                      tag: "component",
                                      class: {
                                        "full-height": _vm.$q.screen.gt.sm
                                      }
                                    },
                                    [
                                      _c("bj-filters", {
                                        key: _vm.filtersResetReRenderKey,
                                        ref: "filtersModal",
                                        attrs: { fields: _vm.filterFields },
                                        on: {
                                          reset: function($event) {
                                            _vm.filtersResetReRenderKey++
                                          },
                                          input: _vm.initFilters
                                        },
                                        model: {
                                          value: _vm.filters,
                                          callback: function($$v) {
                                            _vm.filters = $$v
                                          },
                                          expression: "filters"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("bj-data-table", {
                    ref: "dataTable",
                    staticClass: "full-height",
                    attrs: {
                      "with-add-button": false,
                      "with-actions-column": _vm.selectedTab === "inactive",
                      "with-cell-delete-button": false,
                      "with-cell-edit-button": false,
                      "filter-button": true,
                      "query-params": _vm.queryParams,
                      columns: _vm.columns,
                      "many-name": "Businesses",
                      "single-name": "business"
                    },
                    on: {
                      "toggle-filters": _vm.toggleFiltersDesktop,
                      fetch: _vm.fetchData
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell-name",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "app.businesses.profile",
                                    params: { id: row.id }
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(row.name) +
                                    " (" +
                                    _vm._s(
                                      row.account_owner
                                        ? row.account_owner.full_name
                                        : ""
                                    ) +
                                    ")\n              "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-units_count",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.active_units_count) +
                                "/" +
                                _vm._s(row.units_count) +
                                "\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-markets",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  row.markets
                                    .map(function(market) {
                                      return market.name
                                    })
                                    .join(", ")
                                ) +
                                "\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell-last_activity_at",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.last_activity_at
                              ? _c("SdDatetime", {
                                  attrs: { value: row.last_activity_at }
                                })
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-current_period_start_at",
                        fn: function(ref) {
                          var row = ref.row
                          return row.subscription
                            ? [
                                _c("SdDatetime", {
                                  attrs: {
                                    value:
                                      row.subscription.current_period_start_at
                                  }
                                })
                              ]
                            : undefined
                        }
                      },
                      {
                        key: "cell-created_at",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("SdDatetime", {
                              attrs: { value: row.created_at }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell-business_name",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.business
                              ? _c("span", [_vm._v("row.business.name")])
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell-actions",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.cannot_be_deleted
                              ? _c("q-tooltip", [
                                  _vm._v(
                                    "\n                Cannot delete a business which has had a subscription\n              "
                                  )
                                ])
                              : _vm._e(),
                            _c("q-btn", {
                              staticClass: "q-ml-sm",
                              attrs: {
                                disabled: !!row.cannot_be_deleted,
                                color: "red",
                                size: "sm",
                                rounded: "",
                                label: "Delete business",
                                icon: "close",
                                outline: ""
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.deleteBusiness(row)
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell-logo_url",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c("img", {
                              staticClass: "logo-url-image",
                              attrs: { src: row.logo_url }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }